import { useCallback, useMemo } from "react";
import { useUserId } from "../../query/hooks/helpers";
import { useQueryMemberProfile } from "../../query/users/queries";
import { selectorMemberCountry } from "../selectors/selectorMemberCountry";
import { isRegionAllowed, RegionConfig } from "../utils/regionConfig";

// Callback
export function useGetMemberRegionIsAllowed() {
  const userId = useUserId();
  const memberProfile = useQueryMemberProfile(userId);

  return useCallback(
    (config: RegionConfig): boolean => {
      if (!memberProfile.data) {
        return false;
      }

      const country = selectorMemberCountry(memberProfile.data);

      return isRegionAllowed(
        config,
        country,
        memberProfile.data.profile.address?.state
      );
    },
    [memberProfile.data]
  );
}

// Memo
export function useMemberRegionIsAllowed(config: RegionConfig) {
  const getIsAllowed = useGetMemberRegionIsAllowed();

  return useMemo(() => getIsAllowed(config), [getIsAllowed, config]);
}
